import React from 'react';

function YellowSvg() {
  return (
    <svg
      width="300"
      height="201"
      viewBox="0 0 300 201"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_1396)">
        <path d="M300 0H0V201H300V0Z" fill="#FAE173" />
        <path
          d="M139.553 118.2C139.461 117.792 139.464 117.368 139.561 116.96C140.315 113.615 140.201 108.68 140.954 104.666C141.708 100.653 144.192 101.105 146.938 100.143C148.691 99.5268 150.332 98.5798 152.199 97.7106C153.312 97.1784 154.463 96.7323 155.643 96.376C159.139 95.3444 167.916 99.0519 172.167 99.7338C173.172 99.8938 174.162 100.135 175.127 100.455L175.147 100.397C175.147 100.397 194.533 87.0839 199.601 83.4381C204.669 79.7922 215.074 72.3896 215.074 72.3896L226.924 99.7328C226.924 99.7328 203.658 115.14 200.214 118.177C196.772 121.215 189.199 125.075 189.199 125.075L189.138 125.061C188.675 127.182 187.138 129.602 182.898 132.001L182.642 132.09C181.941 130.472 181.054 128.942 179.999 127.531C175.771 119.738 158.526 108.191 157.035 108.439C155.544 108.688 151.427 109.231 151.427 109.231C151.124 110.142 149.858 110.652 149.858 110.652H149.75C149.771 113.409 148.825 116.086 147.079 118.216C144.321 121.703 140.12 120.714 139.553 118.2Z"
          fill="#FFCEB6"
        />
        <path
          d="M187.517 49.6086C187.788 50.8518 187.893 52.1255 187.829 53.3963C187.815 53.6189 187.756 53.8358 187.653 54.0337C187.551 54.2313 187.408 54.4053 187.234 54.544C187.06 54.6827 186.859 54.7832 186.643 54.839C186.428 54.8947 186.203 54.9044 185.984 54.8671L180.223 53.9144C179.87 53.8578 179.547 53.6824 179.306 53.4173C179.066 53.1518 178.923 52.8124 178.901 52.4548C178.878 51.5049 178.536 50.5907 177.93 49.86C177.682 49.5716 177.404 49.3112 177.101 49.0823L175.443 59.1464L177.811 60.5816C181.068 62.5051 183.161 64.7365 184.089 67.2762C185.018 69.8132 185.264 72.5501 184.803 75.2126C184.511 77.087 183.847 78.8841 182.85 80.4971C181.9 82.0334 180.673 83.3807 179.234 84.4705C177.777 85.5632 176.112 86.3456 174.341 86.7692C173.192 87.0516 172.011 87.1818 170.828 87.1568L170.034 91.9761C169.99 92.2428 169.894 92.4986 169.752 92.7284C169.609 92.9582 169.423 93.1573 169.203 93.3151C168.983 93.4726 168.735 93.5853 168.472 93.6467C168.209 93.708 167.936 93.7168 167.67 93.6727C167.403 93.6285 167.148 93.5324 166.919 93.3893C166.69 93.2466 166.491 93.0597 166.333 92.8396C166.176 92.6198 166.064 92.3709 166.003 92.1072C165.941 91.8436 165.932 91.5706 165.976 91.3039L166.761 86.5437C163.931 85.7905 161.429 84.1205 159.645 81.7946C158.776 80.6956 158.095 79.4602 157.631 78.1381C157.488 77.7448 157.361 77.3409 157.25 76.9217C156.959 75.8313 156.804 74.7088 156.788 73.5802C156.779 73.2136 156.852 72.8494 156.999 72.5138C157.148 72.1785 157.367 71.8798 157.643 71.6391C157.92 71.3983 158.246 71.2214 158.598 71.1209C158.95 71.0207 159.32 70.9991 159.681 71.0583L162.115 71.4637L163.842 71.7483C164.353 71.8347 164.825 72.0789 165.192 72.4465C165.558 72.8144 165.802 73.2874 165.887 73.8C166.008 74.5094 166.213 75.2016 166.499 75.8619C166.839 76.6418 167.457 77.2671 168.232 77.6152L170.102 66.2628L168.035 65.0868C165.473 63.687 163.357 61.5897 161.933 59.0368C160.593 56.4717 160.166 53.5256 160.723 50.6847C161.015 48.8061 161.695 47.0097 162.719 45.4092C163.695 43.8848 164.967 42.573 166.459 41.5517C167.884 40.5298 169.507 39.8188 171.223 39.4643C172.321 39.2349 173.442 39.1369 174.562 39.1716L175.26 34.9331C175.349 34.3939 175.648 33.9121 176.091 33.5937C176.311 33.4362 176.559 33.3235 176.822 33.2618C177.085 33.2005 177.358 33.1914 177.624 33.2355C177.891 33.2797 178.146 33.3761 178.376 33.5189C178.605 33.6616 178.804 33.8486 178.961 34.0687C179.119 34.2884 179.231 34.5373 179.293 34.801C179.354 35.0646 179.363 35.3376 179.319 35.6046L178.623 39.8325C179.737 40.1669 180.801 40.6466 181.789 41.2599C183.257 42.1625 184.517 43.3669 185.486 44.7937C186.464 46.2539 187.154 47.8882 187.517 49.6086ZM175.981 73.9418C176.207 72.7665 176.044 71.5492 175.516 70.4753C175.111 69.7383 174.555 69.0959 173.883 68.5909L172.332 78.0053C172.834 77.8635 173.317 77.6575 173.767 77.392C174.376 77.0269 174.893 76.5257 175.278 75.9271C175.662 75.3284 175.903 74.649 175.981 73.9418ZM171.655 56.8158L173.088 48.123C172.409 48.2404 171.776 48.54 171.254 48.9899C170.326 49.7654 169.712 50.8537 169.527 52.0503C169.387 52.9317 169.464 53.834 169.752 54.6784C170.149 55.5716 170.814 56.3189 171.655 56.8158Z"
          fill="#CCEFF6"
        />
        <path
          d="M139.552 118.2C140.119 120.714 144.321 121.7 147.075 118.217C148.821 116.086 149.766 113.41 149.746 110.653H149.854C149.854 110.653 151.12 110.143 151.423 109.232C151.423 109.232 155.537 108.688 157.031 108.44C158.525 108.192 175.766 119.739 179.995 127.532C181.049 128.943 181.937 130.473 182.638 132.09C183.097 133.278 183.272 134.409 182.719 135.065C180.813 137.335 178.482 136.667 176.846 134.78C176.765 134.688 176.684 134.59 176.603 134.491C174.959 132.386 170.738 127.249 170.738 127.249L167.217 125.06C168.038 125.83 168.81 126.652 169.526 127.521C170.469 128.809 174.177 132.602 175.843 135.202C176.272 135.765 176.553 136.426 176.662 137.125C176.627 137.636 176.47 138.132 176.206 138.571C175.942 139.01 175.577 139.379 175.142 139.648C174.707 139.918 174.214 140.08 173.704 140.12C173.194 140.161 172.682 140.079 172.21 139.882C172.151 139.858 172.095 139.828 172.042 139.793C170.632 138.918 163.692 132.681 162.615 131.664C162.4 131.263 162.103 130.912 161.745 130.632C161.528 130.458 161.297 130.301 161.054 130.165L161.044 130.156C159.219 129.116 157.221 129.507 155.496 130.858C153.593 132.355 154.428 131.471 153.605 132.33C153.534 131.654 153.246 131.021 152.784 130.524C151.079 128.606 148.767 128.511 146.592 129.685C144.912 130.651 143.292 131.718 141.74 132.879L135.408 133.486L135.353 133.475C135.508 132.347 135.264 131.199 134.663 130.232C133.287 128.153 131.222 128.367 130.135 128.432C129.956 128.444 129.78 128.475 129.608 128.527L129.595 128.432C128.752 128.016 127.935 127.549 127.15 127.032C126.12 126.388 125.002 125.647 124.109 125.045C123.125 124.382 122.418 123.892 122.418 123.892C122.484 115.85 123.069 107.822 124.167 99.8559L125.595 100.411C127.909 101.311 132.282 103.006 132.841 103.203C133.109 103.345 133.407 103.418 133.709 103.418C134.012 103.418 134.31 103.345 134.577 103.203C135.37 102.903 144.689 97.9862 146.572 97.5378C148.456 97.0892 152.194 97.7072 152.194 97.7072C150.324 98.5798 148.684 99.5268 146.933 100.14C144.19 101.102 141.701 100.647 140.949 104.663C140.198 108.679 140.31 113.612 139.556 116.957C139.46 117.365 139.459 117.791 139.552 118.2Z"
          fill="#FFCEB6"
        />
        <path
          d="M176.612 134.49C176.693 134.59 176.774 134.688 176.855 134.779C176.855 134.779 175.876 135.234 175.857 135.203C174.191 132.603 170.482 128.81 169.539 127.522C168.823 126.653 168.052 125.831 167.23 125.061L170.752 127.25C170.752 127.25 174.968 132.386 176.612 134.49Z"
          fill="#FFCEB6"
        />
        <path
          d="M172.052 139.793L171.861 140.075C171.788 140.453 171.629 140.809 171.396 141.115C171.162 141.421 170.86 141.668 170.514 141.837C170.023 142.146 169.474 142.349 168.9 142.435C168.326 142.52 167.741 142.485 167.182 142.332C166.68 142.089 166.196 141.81 165.733 141.499L164.992 141.418C165.366 141.072 165.697 140.681 165.977 140.255C167.029 138.478 166.993 137.377 165.832 136.452C165.396 136.038 164.859 135.747 164.276 135.607C163.692 135.466 163.082 135.482 162.506 135.652L162.383 135.576C162.445 135.473 162.499 135.364 162.545 135.252C162.822 134.698 162.973 134.089 162.987 133.469C163.001 132.849 162.877 132.234 162.626 131.668C163.702 132.681 170.639 138.918 172.052 139.793Z"
          fill="#FFCEB6"
        />
        <path
          d="M167.181 142.332C166.196 143.555 164.849 144.434 163.334 144.841C163.015 144.956 162.675 145 162.337 144.971C162 144.941 161.673 144.837 161.379 144.668L161 144.663C162.399 143.669 163.732 142.585 164.992 141.419L165.732 141.5C166.196 141.811 166.68 142.089 167.181 142.332Z"
          fill="#FFCEB6"
        />
        <path
          d="M165.832 136.445C166.993 137.37 167.026 138.472 165.977 140.249C165.697 140.675 165.366 141.065 164.992 141.412C163.733 142.578 162.399 143.661 161 144.655C160.536 144.993 160.239 145.198 160.239 145.198C155.659 147.894 153.628 148.492 151.99 147.72C151.483 147.517 151.028 147.201 150.659 146.797C150.291 146.393 150.018 145.91 149.863 145.385L149.782 145.201C151.62 144.394 153.401 143.462 155.112 142.412C155.112 142.412 161.101 137.743 162.38 135.567L162.503 135.642C163.08 135.472 163.691 135.457 164.275 135.598C164.859 135.739 165.396 136.031 165.832 136.445Z"
          fill="#FFCEB6"
        />
        <path
          d="M162.626 131.661C162.878 132.227 163.001 132.842 162.987 133.462C162.973 134.082 162.822 134.691 162.545 135.245C162.5 135.357 162.446 135.466 162.383 135.569C161.104 137.746 155.115 142.414 155.115 142.414C153.404 143.465 151.623 144.397 149.785 145.203C145.981 146.79 145.095 145.852 143.729 145.209C142.427 144.52 141.449 143.344 141.008 141.937V141.898C142.14 141.814 143.244 141.511 144.261 141.006C144.261 141.006 151.682 137.033 152.798 135.201C153.379 134.359 153.667 133.348 153.619 132.325C154.442 131.466 153.607 132.35 155.51 130.853C157.235 129.501 159.233 129.112 161.057 130.151L161.068 130.16C161.311 130.297 161.542 130.453 161.758 130.628C162.117 130.908 162.412 131.26 162.626 131.661Z"
          fill="#FFCEB6"
        />
        <path
          d="M141.744 132.877C143.299 131.717 144.92 130.65 146.601 129.683C148.776 128.509 151.088 128.604 152.793 130.522C153.255 131.019 153.543 131.653 153.614 132.328C153.662 133.351 153.374 134.362 152.793 135.204C151.678 137.035 144.256 141.009 144.256 141.009C143.239 141.514 142.135 141.817 141.004 141.901C138.853 141.973 136.706 141.671 134.658 141.009C132.425 140.429 131.359 136.244 131.359 136.244C132.214 136.104 133.047 135.851 133.835 135.491C134.238 135.31 134.589 135.031 134.856 134.678C135.122 134.326 135.296 133.911 135.36 133.474L135.415 133.484L141.744 132.877Z"
          fill="#FFCEB6"
        />
        <path
          d="M151.167 31.1414L151.692 33.6893L120.389 40.152L128.876 81.4196L126.331 81.9434L125.805 79.3933L117.321 38.1288L148.622 31.6661L151.167 31.1414Z"
          fill="#CCEFF6"
        />
        <path
          d="M148.622 31.6659L117.321 38.1289L125.805 79.3933L123.26 79.9203L114.249 36.1023L148.099 29.1157L148.622 31.6659Z"
          fill="#006B99"
        />
        <path
          d="M129.616 128.526C129.787 128.474 129.963 128.443 130.142 128.431C131.23 128.369 133.29 128.152 134.67 130.231C135.271 131.198 135.516 132.346 135.361 133.475C135.296 133.912 135.122 134.326 134.856 134.679C134.59 135.032 134.239 135.311 133.836 135.492C133.047 135.852 132.215 136.105 131.36 136.245C129.46 136.565 127.485 136.392 126.617 135.537C125.16 134.096 123.593 130.785 126.996 127.288L127.157 127.031C127.943 127.547 128.76 128.015 129.603 128.43L129.616 128.526Z"
          fill="#FFCEB6"
        />
        <path
          d="M125.115 98.4566L125.084 98.482C125.054 98.4416 125.016 98.4084 124.971 98.3846C124.927 98.3611 124.878 98.3477 124.828 98.3451C124.777 98.3426 124.727 98.3514 124.681 98.3708C124.634 98.3902 124.593 98.4193 124.559 98.4566C124.345 98.8949 124.215 99.3692 124.174 99.8555C123.076 107.821 122.492 115.85 122.425 123.891C122.461 125.744 122.608 126.965 122.906 127.13C123.092 127.258 123.321 127.308 123.543 127.268L123.554 127.305C122.726 127.857 120.514 128.135 119.912 126.383C119.764 124.962 119.753 123.53 119.879 122.107C120.166 115.214 121.287 102.24 121.903 98.6855C121.936 98.3761 122.012 98.0728 122.131 97.7854C122.795 96.9128 125.037 97.4147 125.115 98.4566Z"
          fill="#CCEFF6"
        />
        <path
          d="M121.753 98.6575L121.906 98.686C121.288 102.245 120.167 115.218 119.883 122.108H119.802C119.802 122.108 115.006 119.951 112.569 119.66C109.036 119.243 73.1425 102.543 73.1425 102.543L86.8763 75.7429L119.521 97.5452L121.753 98.6575Z"
          fill="#FFCEB6"
        />
        <path
          d="M215.07 72.3896L226.921 99.7328"
          stroke="#FFCEB6"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M73.1394 102.539L86.876 75.7429"
          stroke="#FFCEB6"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M186.771 160.32C178.188 165.999 168.269 169.324 158.004 169.965C147.738 170.607 137.484 168.54 128.264 163.973C119.044 159.406 111.18 152.497 105.456 143.936C99.7322 135.374 96.3482 125.459 95.6416 115.179"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M213.131 112.915C212.888 121.327 210.845 129.588 207.142 137.141C203.438 144.694 198.16 151.363 191.664 156.697"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M180.206 150.931C173.8 155.17 166.453 157.77 158.81 158.501C151.167 159.233 143.462 158.075 136.37 155.127C129.278 152.18 123.017 147.535 118.135 141.598C113.253 135.662 109.899 128.616 108.368 121.079"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M200.435 120.47C198.388 131.294 192.609 141.053 184.108 148.041"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M185.878 77.1104C188.655 79.621 191.123 82.4538 193.23 85.5495"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M112.438 90.8285C114.603 86.4735 117.426 82.4801 120.809 78.9895"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M183.108 59.7283C190.511 63.9014 196.931 69.6227 201.93 76.5033"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M102.341 83.5494C106.104 76.4558 111.269 70.2035 117.521 65.1738"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M175.149 100.396C175.149 100.396 194.535 87.083 199.603 83.4371C204.672 79.7916 215.074 72.3896 215.074 72.3896"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M189.198 125.076C189.198 125.076 196.769 121.212 200.213 118.177C203.657 115.142 226.923 99.7329 226.923 99.7329"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M73.1394 102.539C73.1394 102.539 109.033 119.243 112.566 119.657C115.003 119.947 119.799 122.104 119.799 122.104"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M121.754 98.6569L119.521 97.5452L86.8759 75.7429"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M125.63 100.338C125.582 99.6873 125.396 99.0546 125.084 98.482C125.054 98.4416 125.015 98.4084 124.971 98.3846C124.927 98.3611 124.877 98.3476 124.827 98.3451C124.777 98.3426 124.727 98.3514 124.681 98.3708C124.634 98.3899 124.592 98.4193 124.559 98.4566C124.345 98.8949 124.215 99.3692 124.174 99.8555C123.076 107.821 122.492 115.85 122.425 123.891C122.461 125.744 122.608 126.965 122.906 127.13C123.092 127.258 123.321 127.308 123.543 127.268C124.272 127.079 124.036 125.282 124.036 125.282"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M125.115 98.4565C125.034 97.4146 122.795 96.9158 122.136 97.785C122.017 98.0727 121.94 98.3757 121.908 98.6851C121.29 102.244 120.169 115.217 119.884 122.107C119.758 123.53 119.769 124.962 119.917 126.383C120.515 128.135 122.727 127.857 123.559 127.304"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M124.174 99.8553L125.602 100.41C127.916 101.31 132.289 103.005 132.848 103.203C133.116 103.344 133.414 103.418 133.717 103.418C134.019 103.418 134.317 103.344 134.585 103.203C135.377 102.902 144.696 97.9853 146.58 97.537C148.463 97.0886 152.202 97.7063 152.202 97.7063"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M122.425 123.891C122.425 123.891 123.132 124.381 124.116 125.045C125.006 125.646 126.127 126.387 127.157 127.031C127.942 127.548 128.759 128.015 129.602 128.431"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M188.919 119.76C188.919 120.937 189.622 122.832 189.136 125.061C188.673 127.182 187.136 129.602 182.896 132.001"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M178.957 102.283C177.775 101.493 176.486 100.877 175.129 100.455C174.164 100.134 173.174 99.8929 172.17 99.7329C167.919 99.0525 159.139 95.3434 155.645 96.3747C154.465 96.731 153.314 97.1775 152.202 97.7094C150.332 98.582 148.691 99.5291 146.941 100.142C144.197 101.104 141.708 100.649 140.957 104.666C140.206 108.682 140.317 113.614 139.563 116.959C139.466 117.366 139.463 117.791 139.555 118.199C140.122 120.713 144.323 121.7 147.077 118.216C148.824 116.086 149.769 113.409 149.748 110.652C149.743 109.875 149.655 109.1 149.487 108.341"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M149.857 110.652C149.857 110.652 151.123 110.142 151.425 109.231C151.425 109.231 155.539 108.687 157.033 108.439C158.528 108.191 175.769 119.738 179.997 127.531"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M179.997 127.531C181.052 128.943 181.939 130.473 182.641 132.09C183.099 133.278 183.274 134.409 182.722 135.064C180.815 137.335 178.484 136.666 176.849 134.78C176.768 134.688 176.687 134.59 176.606 134.49C174.961 132.386 170.741 127.249 170.741 127.249L167.22 125.059"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M161.064 117.581C161.136 118.332 161.324 119.067 161.621 119.76C161.852 120.028 164.928 122.807 167.226 125.061C168.047 125.831 168.818 126.653 169.535 127.522C170.478 128.81 174.187 132.603 175.852 135.204C176.28 135.766 176.562 136.427 176.67 137.126C176.635 137.637 176.479 138.133 176.215 138.572C175.951 139.01 175.586 139.38 175.151 139.649C174.716 139.919 174.223 140.08 173.713 140.121C173.203 140.162 172.691 140.08 172.219 139.883C172.16 139.859 172.104 139.829 172.051 139.794C170.641 138.919 163.701 132.682 162.624 131.665L162.619 131.659"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M171.86 140.074C171.788 140.453 171.629 140.809 171.396 141.115C171.162 141.421 170.86 141.668 170.514 141.836C170.023 142.146 169.473 142.349 168.9 142.434C168.326 142.52 167.741 142.485 167.181 142.332C166.68 142.088 166.196 141.81 165.733 141.499"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M167.182 142.332C166.196 143.555 164.849 144.433 163.334 144.841C163.016 144.956 162.675 145 162.338 144.97C162 144.94 161.673 144.837 161.379 144.668"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M157.033 108.44C157.033 108.44 158.291 107.191 158.291 106.48"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M151.425 109.231C151.537 108.645 151.537 108.044 151.425 107.458"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M139.489 117.941C139.488 118.032 139.51 118.122 139.553 118.202C140.056 119.222 143.587 118.893 144.719 117.194C145.939 115.357 144.448 112.915 144.448 112.915"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M140.24 112.252C140.24 112.252 141.146 112.182 142.344 112.043"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M179.594 135.204C180.422 134.958 181.183 134.525 181.816 133.938"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M176.851 134.78C176.851 134.78 175.872 135.234 175.852 135.203"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.685 129.552C128.27 129.11 128.922 128.764 129.616 128.53C129.787 128.478 129.963 128.447 130.142 128.435C131.23 128.373 133.29 128.156 134.67 130.235C135.271 131.202 135.516 132.35 135.361 133.479C135.296 133.916 135.122 134.33 134.856 134.683C134.59 135.036 134.239 135.315 133.836 135.496C133.047 135.856 132.215 136.109 131.36 136.249C129.46 136.569 127.485 136.396 126.617 135.541C125.16 134.1 123.593 130.789 126.996 127.292"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M141.744 132.877C141.102 133.346 140.568 133.744 140.237 133.99"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M131.36 136.245C131.36 136.245 132.426 140.431 134.659 141.011C136.707 141.673 138.854 141.975 141.005 141.903C142.136 141.818 143.24 141.515 144.257 141.011C144.257 141.011 151.679 137.038 152.794 135.206C153.375 134.363 153.663 133.353 153.615 132.33C153.544 131.654 153.256 131.021 152.794 130.524C151.089 128.606 148.777 128.511 146.602 129.685C144.923 130.652 143.303 131.718 141.75 132.879"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M141.75 132.878H141.748L135.416 133.486"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M146.752 132.545C146.225 133.169 145.938 133.962 145.942 134.779C145.982 135.124 146.105 135.453 146.301 135.738C146.497 136.024 146.76 136.256 147.067 136.416C147.374 136.576 147.715 136.657 148.061 136.654C148.407 136.65 148.746 136.562 149.05 136.396C150.488 135.599 152.792 133.985 152.158 132.545"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M147.739 131.661C148.242 131.214 148.855 130.911 149.514 130.782C149.978 130.763 150.432 130.919 150.786 131.22"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M161.054 130.156C159.229 129.116 157.231 129.507 155.506 130.858C153.604 132.355 154.438 131.471 153.615 132.33C153.598 132.347 153.582 132.366 153.562 132.386"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M141.008 141.942C141.449 143.349 142.426 144.525 143.728 145.214C145.094 145.858 145.984 146.794 149.784 145.208C151.622 144.401 153.403 143.47 155.115 142.419C155.115 142.419 161.104 137.75 162.383 135.574C162.445 135.471 162.499 135.362 162.545 135.25C162.822 134.695 162.973 134.086 162.987 133.467C163.001 132.847 162.877 132.232 162.626 131.666C162.411 131.265 162.114 130.913 161.756 130.634C161.539 130.459 161.308 130.303 161.065 130.166"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M156.138 133.65C155.726 134.357 155.579 135.187 155.723 135.992C155.82 136.324 155.998 136.627 156.239 136.875C156.481 137.123 156.779 137.307 157.108 137.412C157.438 137.517 157.788 137.54 158.128 137.478C158.468 137.416 158.788 137.271 159.059 137.056C160.344 136.026 162.338 134.044 161.471 132.731"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M156.961 132.609C157.38 132.084 157.932 131.682 158.56 131.443C159.014 131.344 159.489 131.421 159.89 131.658"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M149.862 145.392C150.018 145.917 150.29 146.4 150.659 146.804C151.027 147.209 151.483 147.525 151.99 147.727C153.628 148.499 155.659 147.9 160.238 145.205C160.238 145.205 160.536 145 161 144.662C162.399 143.668 163.732 142.585 164.992 141.419C165.366 141.072 165.697 140.682 165.977 140.256C167.029 138.479 166.993 137.377 165.832 136.452C165.396 136.039 164.859 135.747 164.275 135.607C163.692 135.467 163.081 135.482 162.506 135.653"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M161.259 138.358C160.941 138.904 160.828 139.545 160.939 140.167C161.014 140.424 161.151 140.659 161.338 140.852C161.525 141.043 161.756 141.186 162.011 141.268C162.266 141.349 162.537 141.367 162.8 141.319C163.063 141.27 163.311 141.158 163.521 140.991C164.514 140.194 166.058 138.662 165.382 137.644"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M161.898 137.55C162.223 137.144 162.652 136.833 163.139 136.649C163.49 136.572 163.857 136.633 164.165 136.817"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M158.291 126.625L159.223 128.406L161.054 130.156L161.064 130.165"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M133.836 135.493C133.028 135.122 132.291 134.611 131.658 133.986C131.228 133.425 130.93 132.774 130.787 132.082C130.757 131.925 130.686 131.779 130.583 131.658C130.479 131.538 130.346 131.446 130.196 131.392C130.046 131.338 129.885 131.325 129.728 131.352C129.571 131.38 129.424 131.448 129.302 131.55C128.912 131.838 128.64 132.258 128.534 132.731C128.411 133.275 128.474 133.844 128.714 134.347C128.953 134.851 129.354 135.259 129.852 135.507"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M157.61 78.1445L129.399 83.9666L128.876 81.4197L120.389 40.1521L151.692 33.6891L154.235 33.1653L162.113 71.4586"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M128.876 81.4196L126.331 81.9434L125.805 79.3933L117.321 38.1288L148.622 31.6661L151.167 31.1414L151.692 33.6893V33.6915"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M125.805 79.3933L123.26 79.9203L114.249 36.1023L148.099 29.1157L148.622 31.6659"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M126.973 44.8707L150.051 40.1074"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M129.293 49.709L152.372 44.9426"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.274 52.7831L152.897 47.4929"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M127.797 55.3327L153.42 50.0435"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M128.323 57.883L146.31 54.1682"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M131.391 59.9071L154.469 55.1438"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M129.372 62.9808L154.995 57.6941"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M129.894 65.5305L155.518 60.2412"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M132.963 67.5567L156.044 62.7913"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.943 70.6308L156.567 65.3416"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M131.468 73.1812L157.092 67.8916"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M139.65 78.1364L142.262 77.5989L145.366 76.9574L151.815 75.6252L153.039 75.3713L155.095 74.948"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M147.248 74.2039C147.167 74.4997 146.666 76.3616 147.357 76.3811C148.102 76.403 149.802 72.1084 149.802 72.1084C149.802 72.1084 148.97 75.5952 149.977 75.6675C150.983 75.7396 150.837 73.187 151.71 72.9503C152.325 72.7825 151.816 74.6052 151.816 75.6262C151.816 76.0639 151.91 76.356 152.225 76.2749C152.617 76.1776 152.853 75.8069 153.04 75.3717C153.346 74.6419 153.521 73.7327 154.067 73.5965"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.011 75.4579C144.367 76.3248 144.901 76.9986 145.351 76.8934C146.375 76.6451 147.137 74.5189 147.246 74.2037C147.248 74.1943 147.25 74.1849 147.254 74.1761V74.168"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M144.011 75.4579C144.836 73.8969 145.293 72.066 144.305 72.3199C143.347 72.5679 143.5 74.209 144.011 75.4579Z"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M142.243 77.5064C142.797 77.3565 143.481 76.4645 144.012 75.4583"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M138.054 75.1013L136.774 77.049L135.494 78.9942"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M134.829 75.7671L136.774 77.0492L138.716 78.3287"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M157.629 78.1368C158.094 79.4587 158.774 80.6944 159.643 81.793C161.427 84.1186 163.929 85.7883 166.759 86.5425L165.975 91.3023C165.931 91.5694 165.939 91.8424 166.001 92.106C166.062 92.3693 166.174 92.6182 166.332 92.8383C166.489 93.0581 166.688 93.245 166.917 93.3881C167.147 93.5308 167.402 93.6273 167.668 93.6714C167.935 93.7156 168.207 93.7065 168.47 93.6451C168.733 93.5838 168.982 93.471 169.201 93.3136C169.421 93.1561 169.607 92.9567 169.75 92.7268C169.893 92.497 169.989 92.2416 170.033 91.9745L170.826 87.1555C172.009 87.1806 173.19 87.0503 174.34 86.7679C176.11 86.3437 177.775 85.5607 179.232 84.4674C180.672 83.3775 181.898 82.0306 182.848 80.494C183.846 78.882 184.51 77.0864 184.803 75.2126C185.264 72.5501 185.017 69.8129 184.088 67.2756C183.159 64.7349 181.067 62.5033 177.81 60.5809L175.443 59.1458L177.1 49.082C177.404 49.3105 177.682 49.5713 177.929 49.8594C178.536 50.5901 178.878 51.5043 178.9 52.4542C178.922 52.8118 179.065 53.1511 179.306 53.4166C179.546 53.6818 179.869 53.8571 180.222 53.9138L185.983 54.8668C186.202 54.9038 186.427 54.8941 186.642 54.8384C186.858 54.7826 187.059 54.6821 187.233 54.5434C187.407 54.4047 187.55 54.231 187.652 54.0331C187.755 53.8352 187.815 53.6183 187.828 53.3957C187.892 52.1249 187.787 50.8512 187.516 49.608C187.152 47.8895 186.463 46.2567 185.486 44.7981C184.516 43.3713 183.256 42.1669 181.788 41.264C180.8 40.6509 179.736 40.171 178.623 39.8369L179.318 35.609C179.362 35.342 179.353 35.069 179.292 34.8054C179.23 34.5417 179.118 34.2928 178.961 34.0727C178.803 33.853 178.604 33.666 178.375 33.5233C178.145 33.3802 177.89 33.2841 177.624 33.2399C177.357 33.1958 177.084 33.2049 176.822 33.2662C176.558 33.3276 176.31 33.4403 176.09 33.5981C175.647 33.9165 175.348 34.3983 175.259 34.9375L174.561 39.176C173.441 39.1409 172.32 39.2392 171.223 39.4687C169.506 39.8232 167.883 40.5342 166.458 41.5561C164.966 42.5774 163.694 43.8892 162.718 45.4133C161.694 47.0138 161.014 48.8105 160.722 50.689C160.165 53.53 160.592 56.4761 161.932 59.0412C163.356 61.5941 165.472 63.6914 168.035 65.0912L170.099 66.2647L168.23 77.6171C167.454 77.2689 166.837 76.6437 166.497 75.8638C166.211 75.2032 166.005 74.5107 165.885 73.8009C165.799 73.2884 165.556 72.8156 165.189 72.4481C164.823 72.0805 164.351 71.8366 163.84 71.7502L162.112 71.4656L159.678 71.0602C159.317 71.001 158.947 71.0226 158.595 71.1228C158.243 71.2233 157.917 71.4002 157.641 71.6406C157.365 71.8814 157.145 72.1804 156.997 72.5157C156.849 72.8513 156.777 73.2154 156.785 73.5821C156.802 74.7107 156.957 75.8328 157.247 76.9236C157.359 77.3397 157.487 77.7436 157.629 78.1368Z"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M169.749 54.6808C169.461 53.8364 169.383 52.9341 169.524 52.0527C169.708 50.8561 170.323 49.7682 171.251 48.9924C171.772 48.5424 172.406 48.2428 173.084 48.1257L171.652 56.8182C170.811 56.3213 170.146 55.5743 169.749 54.6808Z"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M173.769 77.392C173.319 77.6575 172.837 77.8635 172.334 78.005L173.886 68.5906C174.557 69.0959 175.114 69.738 175.519 70.475C176.046 71.5492 176.209 72.7665 175.983 73.9418C175.905 74.6491 175.664 75.3285 175.28 75.9271C174.896 76.5254 174.379 77.0269 173.769 77.392Z"
          stroke="#006B99"
          strokeWidth="3.39567"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_1396">
          <rect width="300" height="201" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default YellowSvg;
